import { createPinia } from "pinia";
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router.js";
import { useThemeStore } from "./stores/theme.js";
import "./style.css";

const app = createApp(App);
app.use(createPinia());
app.use(router);
useThemeStore().init();
app.mount("#app");
